export const modes={
  DEFAULT: 'DEFAULT',
  IMPORT: 'IMPORT',
  REFERENCE: 'REFERENCE'
};